// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.app-container[data-v-fdc29956] {\n  padding:  0 30px;\n}\n.batchNumber[data-v-fdc29956] {\n  color: #007efd;\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
